<template>
  <Col>
    <div v-if="liveshowAllPath" class="siteSelect mb-1" style="height: 26px">
      <span>站点</span>
      <Checkbox class="ml-2" v-model="selectAll" :disabled="loading" @on-change="setSiteAll()">{{ selectSiteAll.memname }}</Checkbox>
      <CheckboxGroup class="liveshowallchgr" v-model="siteSelect">
        <Checkbox v-for="item in selectSite" :key="item.stid" :label="item.stid" :disabled="loading">{{ item.memname }}</Checkbox>
      </CheckboxGroup>
      <template v-if="showTargeSwitch">
        <span class="ml-2 mr-1">标记模式</span>
        <!-- <i-switch size="large" v-model="targetMode" @on-change="upTargetModeValue">
          <span slot="open">{{$t('common.open')}}</span>
          <span slot="close">{{$t('common.close')}}</span>
        </i-switch> -->
        <button :class="['ml-1', 'zodiacBtn', {'focus': item.focus}]" v-for="item in zodiac" :key="item.value" @click="zodicaTarget(item)">{{ item.id }}</button>
        <!-- <span v-if="targetMode">
          <Button class="mx-1" @click="sendTarget">{{$t('common.submit')}}</Button>
          <Button @click="upTargetData(false)">{{$t('common.cancel')}}</Button>
        </span> -->
        </template>
    </div>
    <div>
      <ButtonGroup class="left mr-1" v-if="activeRouter == 'scode'">
        <Button @click="tema = 1" :type="tema == 1 ? 'primary' : 'default'">{{ $t('common.all') }}</Button>
        <Button @click="tema = 2" :type="tema == 2 ? 'primary' : 'default'">{{ $t('lsib.TeMa')+'A' }}</Button>
        <Button @click="tema = 3" :type="tema == 3 ? 'primary' : 'default'">{{ $t('lsib.TeMa')+'B' }}</Button>
      </ButtonGroup>
      <span class="left">盤口</span>
      <Select value="all" class="left btnarea mx-1" v-model="chgbaco">
        <Option v-for="item in selectPlate" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <template v-if="getpermission.inspect[1] == '1'">
        <span class="left">调整赔率</span>
        <Input class="left btnarea mx-1" style="width: 60px" v-model="chodd" />
        <router-view name="selectAllupch"></router-view>
        <ButtonGroup class="left mx-1">
          <Button type="error" :disabled="getliveshow.siteSelect == ''" @click="fix_baco_Odds(1)" icon="md-add">调整</Button>
          <Button type="warning" :disabled="getliveshow.siteSelect == ''" @click="fix_baco_Odds(0)" icon="md-remove">调整</Button>
        </ButtonGroup>
      </template>
      <template v-if="liveshowAllPath">
        <Poptip trigger="hover" title="查看本占比" class="left mx-1" content="content" placement="bottom">
          <span>
            <a>查看本占比</a>
          </span>
          <div slot="content">
            <p v-for="(it, i) in ProportionSelectData" :key="i">
              <span class>{{it.memname}}</span>
              <span class="right">{{it.mytlpa}}%</span>
            </p>
          </div>
        </Poptip>
      </template>
      <template v-if="liveshowAllPath && selectAll">
        <Poptip trigger="hover" title="查看开盘时间" class="left mx-1" content="content" placement="bottom">
          <span>
            <a>查看开盘时间</a>
          </span>
          <div slot="content">
            <open-baco-all-time
              v-for="(it, i) in topbardata.periodstate"
              :key="'time'+i"
              :timeData="{ startdate: topbardata.startdate, ...it}"
              :title="it.memname"
            ></open-baco-all-time>
          </div>
        </Poptip>
      </template>
      <div class="left mx-1">
        <router-view name="tool"></router-view>
      </div>
      <template v-if="liveshowPath || !selectAll">
        <open-baco-time :timeData="timeData"></open-baco-time>
      </template>
      <retime :chgtime="chgtime" :closeaarea="closeaarea" :rTime="rTime" :liveshowAllPath="liveshowAllPath"></retime>
      <Button v-if="liveshowAllPath" type="primary" class="left" :disabled="getliveshow.siteSelect == ''" @click="showQuickModal()">快速变更赔率</Button>
    </div>
    <alert-notice v-if="liveshowAllPath"></alert-notice>
    <quick-odd-change-modal />
  </Col>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import checkpath from "views/liveshow/mixins/checkPath";
export default {
  name: "liveshow-nav-setting-tool",
  mixins: [checkpath],
  components: {
    openBacoTime: () =>
      import(/* webpackChunkName: "openBacoTime" */ "@/components/common/openBacoTime.vue"),
    openBacoAllTime: () =>
      import(/* webpackChunkName: "openBacoAllTime" */ "@/components/common/openBacoAllTime.vue"),
    AlertNotice: () =>
      import(/* webpackChunkName: "liveshow-AlertNotice" */ "@/components/common/AlertNotice"),
    QuickOddChangeModal: () =>
      import(/* webpackChunkName: "QuickOddChangeModal" */ "@/views/liveshow/components/QuickOddChangeModal")
  },
  props: {
    topbardata: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rTime: "10",
      chgtime: "10",
      ProportionSelectIndex: 0,
      ProportionSelectData: [],
      selectSiteAll: {
        stid: false,
        memname: "全部"
      },
      selectAll: false,
      selectSite: [],
      closeaarea: [
        {
          value: "5",
          label: "5"
        },
        {
          value: "10",
          label: "10"
        },
        {
          value: "30",
          label: "30"
        },
        {
          value: "60",
          label: "60"
        }
      ],
      loading: false,
      targetMode: false,
      zodiac: []
    }
  },
  computed: {
    ...mapGetters(["getliveshow", "getmember", "getpermission", "getgameid"]),
    showTargeSwitch () {
      return this.$route.meta.page == 1
    },
    activeRouter () {
      const arr = this.$route.name.split('-')
      return arr[1]
    },
    colSpan () {
      if (this.liveshowPath) {
        const state = ['9', '11', '12', '16'].some(it => it == this.$route.meta.page)
        if (state) {
          return 17
        } else {
          return 20
        }
      } else {
        return 24
      }
      return this.liveshowPath ? 20 : 24
    },
    timeData () {
      if (!Object.keys(this.topbardata).length) return {}
      if (this.liveshowAllPath) {
        return {
          startdate: this.topbardata.startdate,
          ...this.topbardata.periodstate[0]
        }
      } else {
        return this.topbardata
      }
    },
    tema: {
      get () {
        return this.getliveshow.tema;
      },
      set (val) {
        this.chg_liveshow_state({ tema: val });
      }
    },
    chodd: {
      get () {
        return this.getliveshow.default_chodd;
      },
      set (val) {
        this.chg_liveshow_state({ default_chodd: val });
      }
    },
    chgbaco: {
      get () {
        return this.getliveshow.chgbaco;
      },
      set (val) {
        this.chg_liveshow_state({ chgbaco: val });
      }
    },
    siteSelect: {
      get () {
        if (this.getliveshow.siteSelect == '') return []
        if (this.getliveshow.siteSelect == '0') {
          this.selectAll = true
          return this.selectSite.map(item => item.stid)
        }
        return this.getliveshow.siteSelect.split(',')
      },
      set (val) {
        if (val.length == this.selectSite.length) this.chg_liveshow_state({ siteSelect: '0' })
        else this.chg_liveshow_state({ siteSelect: val.join(',') })
      }
    },
    selectPlate () {
      let result = [{ value: 0, label: "全部" }]
      const index = this.liveshowPath ? 2 : 10
      for (let i = 1; i <= index; i++) {
        const plate = String.fromCharCode(64 + i)
        result.push({
          value: i,
          label: `${plate}盤`
        })
      }
      return result
    }
  },
  watch: {
    siteSelect (siteSelect) {
      this.selectAll = siteSelect.length == this.selectSite.length
    },
    "getliveshow.siteSelect" (val) {
      if (this.liveshowPath) return
      this.getProportionList();
    },
    '$route' (to, from) {
      if (this.routerSplit(to.name) != this.routerSplit(from.name)) {
        this.chg_liveshow_state({ siteSelect: '0' })
      }
      this.tema = 1
    },
    liveshowAllPath (val) {
      if (val) {
        this.getSiteList()
        this.getProportionList()
      }
    },
    "getliveshow.targetData" () {
      this.focusZodica()
    },
    "getliveshow.targetModeValue" (bool) {
      if (bool) this.sendTarget()
    }
  },
  created () {
    this.getSiteList()
    this.getProportionList()
  },
  mounted () {
    this.getzodiac()
  },
  methods: {
    ...mapActions(["chg_liveshow_state", "changeloading"]),
    ...mapMutations(["upTargetModeValue", "upTargetData", "deleteTargetData"]),
    async getzodiac () {
      try {
        const zodiaclist = await this.$axios.liveshow.yzodod()
        this.zodiac = zodiaclist.map(item => {
          return {
            id: item.zodiac,
            value: item.yzorder,
            number: item.number.split(','),
            focus: false
          }
        })

        this.focusZodica()
      } catch (error) {
        console.error(error)
      }
    },
    async getSiteList () {
      try {
        this.selectSite = []
        const res = await this.$axios.liveshow.linkstid()
        if ('status' in res && res.status === 0) return
        this.selectSite = this.selectSite.concat(res)
      } catch (error) {
        console.log(error);
      }
    },
    async getProportionList () {
      try {
        this.loading = true
        this.ProportionSelectData = []
        if (this.getliveshow.siteSelect == '') return
        const res = await this.$axios.liveshow.linkmytlpa(this.getliveshow.siteSelect)
        if ('status' in res && res.status === 0) return
        this.ProportionSelectIndex = 0
        this.ProportionSelectData = res
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => {
          this.loading = false
        }, 500);
      }
    },
    fix_baco_Odds (porn) {
      this.changeloading(true);
      const defaultData = {
        proj: this.$route.meta.page == 1 ? this.tema : (this.getliveshow.oddItemSelect.proj || this.getliveshow.proj),
        page: this.$route.meta.page,
        options: this.getliveshow.oddItemSelect.option,
        chodd: this.getliveshow.default_chodd,
        porn: porn,
        baco: this.getliveshow.chgbaco,
        loid: this.getmember.pid,
      };
      const liveshow =
        this.liveshowPath
          ? { mlevel: this.getmember.mlevel, reppid: '1' }
          : { stid: this.getliveshow.siteSelect }
      const data = Object.assign(defaultData, liveshow)
      if (this.getliveshow.siteSelect == '') return
      this.PostFixBacoOdds(data)
    },
    async PostFixBacoOdds (data) {
      try {
        const res =
          this.liveshowPath
            ? await this.$axios.liveshow.fixBacoOdds(this.getgameid, data)
            : await this.$axios.liveshow.linkallupchodd(this.getgameid, data)
        this.changeloading(false);
        if (res.status == 1) {
          this.$Message.success("修改成功");
          if (this.liveshowAllPath) {
            const item = Object.keys(res).filter(it => it != 'status').map(it => res[it])
            this.$Eventhub.$emit('alert-notice', item)
          }
        }
        this.$emit('refresh');
      } catch (error) {
        console.log(error);
      }
    },
    showQuickModal () {
      this.$Eventhub.$emit("quick-odds-changes-modal")
    },
    setSiteAll () {
      if (this.selectAll) {
        this.siteSelect = []
        this.siteSelect = this.selectSite.map(item => item.stid)
      } else {
        this.siteSelect = []
      }
    },
    zodicaTarget (item) {
      if (this.getliveshow.targetModeValue) return

      item.number.forEach(number => {
        if (!item.focus) this.upTargetData(number)
        if (item.focus) this.deleteTargetData(number)
      });

      this.upTargetModeValue(true)
    },
    focusZodica () {
      this.zodiac.forEach(item => {
        item.focus = item.number.every(num => this.getliveshow.targetData.includes(parseInt(num, 10)))
      })
    },
    async sendTarget () {
      try {
        const marklist = this.getliveshow.targetData.join(',')
        await this.$axios.liveshow.analyzeupd({loid: this.getmember.pid, marklist})
      } catch (error) {
        console.error(error)
      } finally {
        setTimeout(() => {
          this.upTargetModeValue(false)
        }, 500);
      }
    },
  }
}
</script>

<style lang="scss">
.siteSelect {
  display: flex;
  .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #1877f2;
    background-color: #1877f2;
  }
  .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after {
    border-color: #fff
  }
  .liveshowallchgr {
    .ivu-checkbox-wrapper {
      margin-right: 5px;
    }
  }
  .zodiacBtn {
    width: 26px;
    height: 26px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
    background: linear-gradient(to bottom, #ffffff 0%,#ebebeb 50%,#d8d8d8 100%);
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      background: linear-gradient(to bottom, #ffff9bd5 0%, #ffff3aef 50%, #ffff00 100%);
    }
    &.focus {
      background: linear-gradient(to bottom, #ffff9bd5 0%, #ffff3aef 50%, #ffff00 100%);
    }
  }
}
</style>